export const receivedTrialContent = data => {
    return {
        type: 'RECEIVED_TRIAL_CONTENT',
        payload: data,
    };
};

export const fetchTrialContent = trialType => async (dispatch, getState, { mainApi }) => {
    const trialRes = await mainApi.get(`v1/subscriptions/plans/${trialType}/trial`);
    const trialData = await trialRes.data;

    dispatch(receivedTrialContent(trialData));
};
